import { getFormValue } from '../utils'
import { getMaxBookingTime } from './get_max_booking_time'

const getPeriodType = (formValues) => {
  const { periodType, startDate, movingType } = formValues

  if (periodType === 'fixed' && startDate) { return periodType }
  if (periodType === 'unlimited' && startDate) { return periodType }
  if (periodType === 'rollingDays') {
    return movingType === 'calendar' ? 'moving' : 'available_moving'
  }

  return null
}

export const prepareValuesForPreview = (eventType, formValues) => ({
  start_date: getFormValue(eventType.start_date, formValues.startDate),
  end_date: getFormValue(eventType.end_date, formValues.endDate),
  period_type: getFormValue(eventType.period_type, getPeriodType(formValues), false),
  max_booking_time: getFormValue(
    eventType.max_booking_time,
    getMaxBookingTime(formValues.maxBookingTime),
    false
  ),
})
